import type {ReactElement} from 'react';
import React from 'react';
import {ItemBaseLetterSpacingOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/item-base-letter-spacing-option';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';
import {useGetKeyFromTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromTranscriptItem';

export function TranscriptLetterSpacingOption(): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptLetterSpacingOption');
  }

  const letterSpacing = useGetKeyFromSubtitleTextStylesForTranscriptItem('letterSpacing', false);
  if (letterSpacing === undefined) {
    throw new Error('Transcript item does not have letterSpacing in sentenceTextStyles');
  }

  const scaleX = useGetKeyFromTranscriptItem('scaleX');
  if (scaleX === undefined) {
    throw new Error('Transcript item does not have scaleX');
  }

  const updateLetterSpacing = async (letterSpacing: number, undoable = true): Promise<void> => {
    await activeItem.updateAllSubtitlesStylesFromSubtitleObject(
      {
        sentenceTextStyles: {letterSpacing},
        activeWordTextStyles: {letterSpacing},
      },
      {undoable}
    );
  };

  return <ItemBaseLetterSpacingOption letterSpacing={letterSpacing} scaleX={scaleX} onChangeLetterSpacing={updateLetterSpacing} />;
}
